/* script for Location page */
$(document).ready(function() {
    if ( $(".section--locations-expanders").length ) {
      var offset = $(".section--locations-expanders").offset().top;
      offset = offset - 50;
      $(".filters-nav-anchor").on("click", function() {
        $("html, body").animate({
          scrollTop: offset
        }, 500);
      });
    }
  
  
    let locationSearchInput = $( '#pac-input' );
  
    let locationSearchResults = $( '#box_location_search' );
  
    if ( locationSearchInput.length > 0 ) {
  
      $( document ).on( 'click', '#box_location_search p', function() {
  
        locationSearchInput.val( $( this ).text() );
  
        locationSearchResults.empty();
  
      } );
    }
  
    /*
    * Populate expert title in the hidden field on clicking email icon
    * on Wrapper-get-in-touch and Wrapper-people-slider blocks
    */
    $('a[data-bs-expert-title]').click( function(event) {
      let expert_title = $( this ).attr('data-bs-expert-title');
      let bs_target = $( this ).attr('data-bs-target');
      let getInTouchForm = $( bs_target ).find( '.mf_form__form' );
      let hidden_field = getInTouchForm.find( 'input[data-hidden-field-tag="expert_title"]' );
      hidden_field.val( expert_title );
    });
  
    $( '.bs-modal-get-in-touch' ).on( 'shown.bs.modal', function () {
  
      let $this = $( this );
  
      let getInTouchForm = $this.find( '.mf_form__form' );
  
      getInTouchForm.trigger( 'reset' );
  
      let select2s = getInTouchForm.find( '.select2-hidden-accessible' );
  
      if ( select2s.length > 0 ) {
  
        select2s.each( function () {
  
          $( this ).val( null ).trigger( 'change' );
  
        } );
      }
  
      // Reset captcha.
      if ( 'undefined' !== typeof grecaptcha ) {
  
        grecaptcha.reset();
      }
  
      getInTouchForm.removeClass( 'was-validated' );
  
      getInTouchForm.show();
  
      $this.find( '.mf_form__success' ).hide();
  
    } );


// Location map adjusts height in case of browser zooming

const updatePixelRatio = () => {
    let pr = window.devicePixelRatio;
    //let prString = (pr * 100).toFixed(0);
    //console.log(`${prString}% (${pr.toFixed(2)})`);
    if(pr > 1.5) {
      $('.section--locations-map #map').css('max-height', '100vh');
    } else {
      $('.section--locations-map #map').css('max-height', 'calc(100vh - 136px)');
    }
    matchMedia(`(resolution: ${pr}dppx)`).addEventListener("change", updatePixelRatio, { once: true })
  }

  updatePixelRatio();
  
  });